// import {
//   FETCH_MUNICIPALITY_REQUEST,
//   FETCH_MUNICIPALITY_SUCCESS,
//   FETCH_MUNICIPALITY_FAILURE,
// } from "../actions/geofenceActions";

// const initialState = {
//   municipalityList: [],
//   loading: false,
//   error: null,
// };

// export default function geofenceReducer(state = initialState, action) {
//   switch (action.type) {
//     case FETCH_MUNICIPALITY_REQUEST:
//       return { ...state, loading: true, error: null };
//     case FETCH_MUNICIPALITY_SUCCESS:
//       return { ...state, loading: false, municipalityList: action.payload };
//     case FETCH_MUNICIPALITY_FAILURE:
//       return { ...state, loading: false, error: action.payload };
//     default:
//       return state;
//   }
// }


import {
  FETCH_MUNICIPALITY_REQUEST,
  FETCH_MUNICIPALITY_SUCCESS,
  FETCH_MUNICIPALITY_FAILURE,
  UPDATE_MUNICIPALITY_REQUEST,
  UPDATE_MUNICIPALITY_SUCCESS,
  UPDATE_MUNICIPALITY_FAILURE,
} from "../actions/geofenceActions";

const initialState = {
  municipalityList: [],
  loading: false,
  error: null,
  updateLoading: false,
  updateSuccess: false,
};

export default function geofenceReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_MUNICIPALITY_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_MUNICIPALITY_SUCCESS:
      return { ...state, loading: false, municipalityList: action.payload };
    case FETCH_MUNICIPALITY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_MUNICIPALITY_REQUEST:
      return { ...state, updateLoading: true, updateSuccess: false };
    case UPDATE_MUNICIPALITY_SUCCESS:
      return { ...state, updateLoading: false, updateSuccess: true };
    case UPDATE_MUNICIPALITY_FAILURE:
      return { ...state, updateLoading: false, error: action.payload };

    default:
      return state;
  }
}
